var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.className,on:{"click":_vm.toggleIcon}},[_c('span',{staticStyle:{"display":"none"},attrs:{"id":'eyeIconSlash_' + this.id}},[_c('i',{staticClass:"far fa-eye-slash eye_icon"})]),_c('span',{attrs:{"id":'eyeIcon_' + this.id}},[_c('i',{staticClass:"far fa-eye eye_icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }